import React, { useEffect, useState } from "react";
import { useTldrawIntegration } from "components/VariablesPanel";
import VariablesPanelV2 from "components/VariablesPanel/VariablesPanelV2";

const VariablesComponent = () => {
  const [isMobile, setIsMobile] = useState(false);

  // Use the Tldraw integration hook
  const {
    onRemoveVariable,
    onAddVariable,
    registerVariableRemovalCallback,
    getActiveVariablesFromCanvas,
    registerVariablesChangeCallback,
    applyPreview,
    clearPreview,
    editor,
  } = useTldrawIntegration();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <VariablesPanelV2
      onAddVariable={onAddVariable}
      onRemoveVariable={onRemoveVariable}
      registerVariableRemovalCallback={registerVariableRemovalCallback}
      getActiveVariablesFromCanvas={getActiveVariablesFromCanvas}
      registerVariablesChangeCallback={registerVariablesChangeCallback}
      applyPreview={applyPreview}
      clearPreview={clearPreview}
      editor={editor}
    />
  );
};

export const Variables = React.memo(VariablesComponent);
